import { Box } from "@mui/material";
import { ArrowIcon, RupinLogoBlack } from "../../../assets/icons/icon";
import styles from "./styles.module.css";
import { ParagraphText } from "../../../Libraries";
import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

const HeaderRupin = ({ children }) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className={`headerRupin ${styles.container}`}>
      <RupinLogoBlack />
      {children ? children : <></>}
    </Box>
  );
};
export default HeaderRupin;